import { useTranslation } from "react-i18next";
import { Navigation } from "@/components/sections/Navigation";
import { useState } from "react";
import { ArrowLeft, ArrowRight, PartyPopper } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { ImportedEventsByCategory } from "@/components/sections/ImportedEventsByCategory";

const SaudiFestivals = () => {
  const { i18n } = useTranslation();
  const isRTL = i18n.language === "ar";
  const navigate = useNavigate();
  const [registrationType, setRegistrationType] = useState("");
  const handleRegistrationClick = () => {};

  return (
    <div className={`min-h-screen flex flex-col bg-gray-100 ${isRTL ? "rtl" : "ltr"}`}>
      <Navigation 
        isRTL={isRTL}
        setRegistrationType={setRegistrationType}
        handleRegistrationClick={handleRegistrationClick}
      />
      <main className="flex-1">
        <section className="py-16">
          <div className="container mx-auto px-4">
            <div className="flex items-center justify-between mb-8">
              <Button
                onClick={() => navigate('/')}
                variant="ghost"
                className="flex items-center gap-2 hover:bg-gray-200"
              >
                {isRTL ? (
                  <>
                    العودة للرئيسية
                    <ArrowRight className="w-4 h-4" />
                  </>
                ) : (
                  <>
                    <ArrowLeft className="w-4 h-4" />
                    Back to Home
                  </>
                )}
              </Button>
              <div className="flex items-center gap-3">
                <div className="p-3 rounded-xl" style={{
                  background: 'linear-gradient(145deg, #ffffff, #e6e6e6)',
                  boxShadow: '5px 5px 15px #d1d1d1, -5px -5px 15px #ffffff'
                }}>
                  <PartyPopper className="h-6 w-6 text-primary" />
                </div>
                <h1 className="text-3xl font-bold text-gray-700">
                  {isRTL ? "المهرجانات" : "Festivals"}
                </h1>
              </div>
            </div>
          </div>
        </section>
        
        {/* Imported Events Section */}
        <ImportedEventsByCategory 
          isRTL={isRTL}
          category="festivals"
          title={{ ar: "المهرجانات", en: "Festivals" }}
        />
      </main>
      <footer className="w-full bg-white border-t mt-auto">
        <div className="max-w-[2000px] mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <p className="text-center text-gray-600 text-sm">
            {isRTL 
              ? "جميع الحقوق محفوظة لـ منصة فعاليات الخليج © ٢٠٢٦" 
              : "All rights reserved to Gulf Events Platform © 2026"}
          </p>
        </div>
      </footer>
    </div>
  );
};

export default SaudiFestivals;
